<p-dialog [visible]="visible()" (visibleChange)="visible.set($event)"
          [header]="header()" [modal]="true" [style]="{ width: width() }"
          [dismissableMask]="dismissableMask()" [styleClass]="styleClass()">
  <ng-content></ng-content>
  <ng-template #footer>
    <ng-content select="[dialogFooter]"></ng-content>
  </ng-template>
</p-dialog>
